export default __webpack_public_path__ + "static/media/Kiunallacover.ae20973d.jpg";